import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const ChevronsDown = forwardRef(function ChevronsDown(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53 7.47a.75.75 0 0 0-1.06 1.06l4 4a.75.75 0 0 0 1.06 0l4-4a.75.75 0 0 0-1.06-1.06L12 10.94 8.53 7.47Zm-2 4a.75.75 0 0 0-1.06 1.06l5.717 5.717.013.014c.053.053.137.137.223.202.11.085.306.204.577.204.271 0 .467-.12.577-.204.086-.065.17-.149.223-.202l.013-.014 5.717-5.717a.75.75 0 1 0-1.06-1.06L12 16.94l-5.47-5.47Z"
        fill="currentColor"
      />
    </Icon>
  );
});
